var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolumeHigh = function SvgVolumeHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7a1 1 0 0 1 1-1h3l4.36-3.633a1 1 0 0 1 1.64.768v13.73a1 1 0 0 1-1.64.768L5 14H2a1 1 0 0 1-1-1V7ZM12.941 17.244a.477.477 0 0 0 .608.339 8 8 0 0 0 0-15.166.477.477 0 0 0-.608.339l-.259.965a.534.534 0 0 0 .348.633 6 6 0 0 1 0 11.292.534.534 0 0 0-.348.633l.26.965Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 13.031c.138.24.446.323.666.157a4 4 0 0 0 0-6.376c-.22-.167-.528-.082-.666.157l-.5.866c-.138.24-.05.541.147.734a2 2 0 0 1 0 2.862c-.197.193-.285.495-.147.734l.5.866Z"
  })));
};
export default SvgVolumeHigh;